// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-search-tsx": () => import("./../../../src/pages/search.tsx" /* webpackChunkName: "component---src-pages-search-tsx" */),
  "component---src-templates-doc-page-tsx": () => import("./../../../src/templates/doc-page.tsx" /* webpackChunkName: "component---src-templates-doc-page-tsx" */),
  "component---src-templates-single-page-tsx": () => import("./../../../src/templates/single-page.tsx" /* webpackChunkName: "component---src-templates-single-page-tsx" */)
}

